export const PEOPLE = [
  {
    initials: "CS",
    name: "Christophe Suchy",
    role: "Co-founder",
    bio: "Serial founder, board member and adviser with a career in mergers and acquisitions, international business and cross-border structuring. Born in France, raised across three countries, and based in Panama City with a second base in Dallas. Co-author of The Global Freedom Blueprint.",
    photo: "/christophe-suchy.webp",
    photoPosition: "50% 20%",
  },
  {
    initials: "GW",
    name: "Gail Warrior",
    role: "Co-founder",
    bio: "More than thirty years as a founder and chief executive, scaling companies in construction, healthcare technology and now global consulting. Gail has raised capital, built inclusive teams, led mergers and acquisitions, and expanded businesses across regulated industries. Co-author of The Global Freedom Blueprint.",
    photo: "/gail-warrior.webp",
  },
];
